export default {
  title: 'Reports',
  description: "Who attended each site over a date range, and for how long. Each report day runs midnight to midnight in each site's time zone.",
  previousPeriod: 'Previous period',
  nextPeriod: 'Next period',
  startDate: 'Start date',
  endDate: 'End date',
  site: 'Site',
  allSites: 'All sites',
  exportCsv: 'Export CSV',
  noAttendanceOn: 'No attendance on {date}',
  noAttendanceRange: 'No attendance from {from} to {to}',
  noAttendanceMessage: 'Nobody was recorded on site in that period. Try another date range, or check that phones were paired and syncing.',
  summaryPersonOne: '<b>{count}</b> person',
  summaryPersonOther: '<b>{count}</b> people',
  summaryTotalOnSite: '<b>{duration}</b> total on site',
  summarySitesOne: '<b>{attended}</b> of {total} site attended',
  summarySitesOther: '<b>{attended}</b> of {total} sites attended',
  personOne: '{count} person',
  personOther: '{count} people',
  noAttendanceAtSite: 'No attendance at this site.',
  colEmployee: 'Employee',
  colFirstEntered: 'First entered',
  colLastExited: 'Last exited',
  colTotal: 'Total',
  stillOnSite: 'Still on site',
  csvStartDate: 'startDate',
  csvEndDate: 'endDate',
  csvSiteId: 'siteId',
  csvSiteName: 'siteName',
  csvSiteTimezone: 'siteTimezone',
  csvHeadcount: 'headcount',
  csvEmployeeId: 'employeeId',
  csvEmployeeName: 'employeeName',
  csvFirstEnteredUtc: 'firstEnteredAtUtc',
  csvFirstEnteredLocal: 'firstEnteredAtLocal',
  csvLastExitedUtc: 'lastExitedAtUtc',
  csvLastExitedLocal: 'lastExitedAtLocal',
  csvTotalMinutes: 'totalMinutes',
  csvTotalHours: 'totalHours',
  csvFilePrefix: 'daily-headcount',
  csvFileRangeJoin: '_to_',
  csvFileAllSites: 'all-sites',
}
